import { ReactNode } from 'react';
import { ColorThemeContext, darkTheme, defaultTheme, grayTheme } from './themes';

interface ColorThemeProviderProps {
  children: ReactNode;
}

export function LightColorTheme({ children }: ColorThemeProviderProps) {
  return (
    <div data-theme="default" style={{ display: 'contents' }}>
      <ColorThemeContext.Provider value={defaultTheme}>{children}</ColorThemeContext.Provider>
    </div>
  );
}

export function DarkColorTheme({ children }: ColorThemeProviderProps) {
  return (
    <div data-theme="dark" style={{ display: 'contents' }}>
      <ColorThemeContext.Provider value={darkTheme}>{children}</ColorThemeContext.Provider>
    </div>
  );
}

export function GrayColorTheme({ children }: ColorThemeProviderProps) {
  return (
    <div data-theme="gray" style={{ display: 'contents' }}>
      <ColorThemeContext.Provider value={grayTheme}>{children}</ColorThemeContext.Provider>
    </div>
  );
}
